export const MAX_PORT_VALUE = 65535;
export const MAX_DESCRIPTION_LENGTH = 3000;
export const MAX_1000_LENGTH = 1000;
export const MAX_500_LENGTH = 500;
export const MAX_450_LENGTH = 450;
export const MAX_250_LENGTH = 250;
export const MAX_256_LENGTH = 256;
export const MAX_255_LENGTH = 255;
export const MAX_150_LENGTH = 150;
export const MAX_100_LENGTH = 100;
export const MAX_60_LENGTH = 60;
export const MAX_50_LENGTH = 50;
export const MAX_70_LENGTH = 70;
export const MAX_80_LENGTH = 80;
export const MAX_30_LENGTH = 30;
export const MAX_20_LENGTH = 20;
export const MAX_15_LENGTH = 15;
export const MAX_12_LENGTH = 12;
export const MAX_10_LENGTH = 10;
export const MAX_11_LENGTH = 11;
export const MAX_7_LENGTH = 7;
export const MAX_5_LENGTH = 5;
export const MAX_3_LENGTH = 3;
export const MAX_2_LENGTH = 2;
